<script>
    import jQuery from "jquery";
    import {getGPTransFunc} from "./gp-translations.js";
    let trans = getGPTransFunc("gp-uploadcustomobject");

    export let imgBase64;
    let uploading = false;
    let name;

    export function open() {
        jQuery('#GPUploadCustomObjectModal').modal({});
        jQuery('#GPUploadCustomObjectModal').on('hidden.bs.modal', () => this.$destroy());

        //manage focus
        jQuery('#GPUploadCustomObjectModal').on('show.bs.modal', GP.storeFocus);
        jQuery('#GPUploadCustomObjectModal').on('hidden.bs.modal', GP.restoreFocus);

        //trap focus
        jQuery('#GPUploadCustomObjectModal .modal-header .close').on('keydown', function(e) {if (e.shiftKey && e.which===9) e.preventDefault();});
        jQuery('#GPObjectConfirm').on('keydown', function(e) {if (!e.shiftKey && e.which===9) e.preventDefault();});

        var i = new Image;
        i.onload = function() {
            jQuery("#customObjectPreview").html(i);
            };
        i.src = imgBase64;

        uploading = false;
    }
    
    async function uploadImage() {
        uploading = true;
        let res = await GPSettings.storageClass.uploadCustomObject(imgBase64, name);

        jQuery('#GPUploadCustomObjectModal').modal('hide');
    }

</script>

<div class="modal fade GPModal" tabindex="-1" id="GPUploadCustomObjectModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{trans( "Upload image")}...</h4>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <div id="customObjectPreview"></div>
                </div>
                <div class="form-group">
                    <label class="control-label" for="GPUploadCustomObjectName">{trans( "Add name")}: </label>
                    <input class="form-control" placeholder='{trans( "Untitled")}' type="text" id="GPUploadCustomObjectName" name="gpcustomobjectname" bind:value={name} required>
                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">{trans( "Cancel")}</button>
                <button id="GPObjectConfirm" type="button" class="btn btn-primary {uploading?'disabled':''}" on:click={uploadImage}>{trans( "Confirm")}
                    {#if uploading}<i class="button-waiting fa fa-spinner fa-spin" style="display: inline-block;"></i>{/if}
                </button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->            
      

